import { Burger, Carousel, Scrollbar, Viewport, TRANSITION_END } from '../core'

$.fn.SubMenu = function() {
  let self = this
  self.items = self.find('.main-menu__sub-menu__item')
  self.carousel = undefined

  self.triggerScrollbarResize = function() {
    requestAnimationFrame(function() {
      self.carousel.swiper.update()
      self.carousel.swiper.updateSize()
      self.carousel.swiper.scrollbar.updateSize()
    })
  }

  return function() {
    if (self.data('submenu')) {
      return self.data('submenu')
    }

    /* Swiper for sub menu */
    let scrollbar = $('<div class="swiper-scrollbar"></div>')
    self.items.addClass('swiper-slide').wrapAll('<div class="swiper-wrapper"></div>')
    self.addClass('swiper-container').append(scrollbar)
    self.carousel = new Carousel(self.get(0), {
      slidesPerView: 'auto',
      freeMode: true,
      freeModeMomentumBounce: true,
      freeModeMomentumBounceRatio: 1.5,
      scrollbar: {
        el: scrollbar.get(0),
        draggable: true,
      },
    })
    self.carousel.init()
    self.data('submenu', self)
    return self
  }()
}

$.fn.MainMenu = function() {
  let self = this
  self.items = self.find('> .main-menu__item--parent')
  self.submenus = self.find('.main-menu__sub-menu')

  self.item_clicked = function(e) {
    if (!$(this).hasClass('main-menu__item--current') && $(this).hasClass('main-menu__item--parent')) {
      self.items.removeClass('main-menu__item--current')
      $(this).addClass('main-menu__item--current')
      e.preventDefault()
    }
  }

  $(window).scroll(function() {
    if ($('body').hasClass('minimize-burger')) {
      if($(document).scrollTop() <= 118){
        $('body').removeClass('minimize-burger');
      }
    } else if($(document).scrollTop() > 118) {
      $('body').addClass('minimize-burger');
    }
  });

  self.resizeScrollbars = function() {
    self.submenus.each(function() {
      $(this).SubMenu().triggerScrollbarResize()
    })
  }

  self.triggerScrollbarResize = function() {
    $('.header-nav').on(TRANSITION_END, function() {
      $('.header-nav').off(TRANSITION_END)
      self.resizeScrollbars()
    })
    $(window).on('resize orientationchange', self.resizeScrollbars)
  }

  self.unbindScrollbarResize = function() {
    $(window).off('resize orientationchange', self.resizeScrollbars)
  }

  return function() {
    self.items.on('click', self.item_clicked)
    self.items.first().trigger('click')
    self.submenus.each(function() {
      $(this).SubMenu()
    })
    return self
  }()
}

export default {
  burger: undefined,
  menu: undefined,

  init() {
    let obj = this
    /* Main menu */
    obj.menu = $('.header .main-menu').MainMenu()

    /* Menu scrollbar  */
    obj.menu_scrollbar = new Scrollbar('.header__nav-block', {
      direction: 'vertical',
      desktop: true,
      mobile: true,
    })

    /* Header viewport */
    new Viewport({
      selector: '.page-header',
      updateDynamically: false,
    })

    /* Burger */
    obj.burger = new Burger('.burger', {
      onToggle: function() {
        if (obj.burger.isExpanded) {
          $('body').addClass('--menu-open')
          obj.menu.triggerScrollbarResize()
        } else {
          $('body').removeClass('--menu-open')
          obj.menu.unbindScrollbarResize()
        }
      },
    })
  }
}
